export default __webpack_public_path__ + "static/media/photo_fl_s_1.765e544d.webp";